import { render, staticRenderFns } from "./MessageIncomingPoll.vue?vue&type=template&id=a0e28fcc&"
import script from "./MessageIncomingPoll.vue?vue&type=script&lang=js&"
export * from "./MessageIncomingPoll.vue?vue&type=script&lang=js&"
import style0 from "./MessageIncomingPoll.vue?vue&type=style&index=0&id=a0e28fcc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VIcon,VImg,VRow})
